export default "__VITE_ASSET__MMGcHwFA__";